.root {
  display: inline-flex;
  gap: 4px;
  background: var(--chartv2-chip-surface, var(--surface-default, transparent));
  border-radius: 8px;
  padding: 4px;
}

.chipWrapper button {
  width: 34px;
  height: 30px;
  padding: 0;
}

.chipWrapper {
  position: relative;
  display: inline-flex;
}

.dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 10;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  background-color: var(--surface-default);
  border-radius: 4px;
  box-shadow: var(--elevation-moderate);
  outline: 1px solid var(--border-soft);
  font-size: 12px;
}

.dropdownItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: transparent;
}

.dropdownItem + .dropdownItem {
  border-top: 1px solid var(--border-soft);
}

.dropdownItem:hover {
  background-color: var(--surface-hover);
}

.dropdownItemDisabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Disable click-handlers baked into the consumer-provided label node
 * so the dropdown row's only action is the toggle on the right. */
.dropdownItemLabel {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}
